module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"madeBy":"Made by","juju":"juju","chillWith":"chill with","chilled cow":"chilled cow"},"fr":{"madeBy":"Fait par","juju":"juju","chillWith":"Détendez-vous avec","chilled cow":"chilled cow"}}')
  delete Component.options._Ctor
}
